import { render, staticRenderFns } from "./SwitchCoverReview.vue?vue&type=template&id=ca3a0826&scoped=true"
import script from "./SwitchCoverReview.vue?vue&type=script&lang=js"
export * from "./SwitchCoverReview.vue?vue&type=script&lang=js"
import style0 from "./SwitchCoverReview.vue?vue&type=style&index=0&id=ca3a0826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a0826",
  null
  
)

export default component.exports